import { Injectable } from '@angular/core';
import { RequestOptions } from '@angular/http';

import { AppSettings } from '../app.settings';
import { CommonRequestService } from './common-request.service';
import { UserService, CustomerChildInfo } from './user.service';
import { AppinfoService } from './appinfo.service';
import { AppinfoPreService } from './appinfo-pre.service';

export interface LBCustomer {
	name: string;
	id: number;
	desc: string;
	parentId?: number;
	children?: CustomerChildInfo[];
	adminEmails: string[];
	type: string;
}

export type FtFactor = FtFactorArray | FtFactorVal;
export interface FtFactorArray {
	type: 'array-single' | 'array-multi';
	list: { name: string; id: number; selected: boolean }[];
	isEditing?: boolean; // Is the ft being edited
}
export interface FtFactorVal {
	type: 'boolean' | 'date';
	value: any;
	isEditing?: boolean; // Is the ft being edited
}
export interface ConditionsUpdate {
	lbt_cgs_id_role: any[];
	lbt_cgs_id_sub_level: any[];
	lbt_trial_expire: Date;
	lbt_sa_only: boolean;
	lbt_ready: boolean;
	lbt_admin_flag: boolean;
	// lbtId: number;
	// app: string;
	// ftName: string;
	// ftLabel: string;
	// factorRole: FtFactor;
	// factorSubLevel: FtFactor;
	// factorTrialExpire: FtFactor; // TODO
	// factorSuperAdmin: FtFactor;
	// factorReady: FtFactor;
	// factorAdminFlag: FtFactor;
}
export interface FeatureToggleSetting {
	lbt_id: number;
	lbt_mod_cd: string;
	lbt_name: string;
	lbt_label: string;
	lbt_cgs_id_role: FtFactor;
	lbt_cgs_id_sub_level: FtFactor;
	lbt_trial_expire: FtFactor;
	lbt_sa_only: FtFactor;
	lbt_ready: FtFactor;
	lbt_admin_flag: FtFactor;
}


@Injectable()
export class SuperAdminService {

	public readonly ftSettingColumnMap = {
		lbt_id: 'lbtId',
		lbtId: 'lbt_id',

		lbt_mod_cd: 'app',
		app: 'lbt_mod_cd',

		lbt_name: 'ftName',
		ftName: 'lbt_name',

		lbt_label: 'ftLabel',
		ftLabel: 'lbt_label',

		lbt_cgs_id_role: 'factorRole',
		factorRole: 'lbt_cgs_id_role',

		lbt_cgs_id_sub_level: 'factorSubLevel',
		factorSubLevel: 'lbt_cgs_id_sub_level',

		lbt_trial_expire: 'factorTrialExpire',
		factorTrialExpire: 'lbt_trial_expire',

		lbt_sa_only: 'factorSuperAdmin',
		factorSuperAdmin: 'lbt_sa_only',

		lbt_ready: 'factorReady',
		factorReady: 'lbt_ready',

		lbt_admin_flag: 'factorAdminFlag',
		factorAdminFlag: 'lbt_admin_flag'
	};
	constructor(
		private appinfoService: AppinfoService,
		private appinfoPreService: AppinfoPreService,
		private requestService: CommonRequestService,
		private userService: UserService
	) { }

	getCustomers(customerId?: number) {
		return new Promise<LBCustomer[]>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/customer';
			const options = customerId ? new RequestOptions({params: {customerId: customerId}}) : null;
			this.requestService.requestGet(url, options, (rsp) => {
				const customers: LBCustomer[] = [];
				if (rsp.data) {
					rsp.data.forEach((d) => {
						const cus = {
							id: d.cus_id,
							name: d.cus_name_short,
							desc: d.cus_name_long,
							parentId: d.cus_parent_id,
							children: d.cus_child ? d.cus_child.map(c => {
								return {
									id: c.id,
									name: c.name,
									adminEmails: c.admin_emails
								};
							}) : [], // d.cus_child,
							adminEmails: d.admin_emails || [],
							type: d.cus_type
						}
						if (cus.children) {
							cus.children.sort(this.userService.sortCusByName);
						}
						customers.push(cus);
					});
					customers.sort(this.userService.sortCusByName);
				}
				resolve(customers);
			}, (err) => {
				console.log('Error calling getCustomers: ', err);
				resolve([]);
			});
		});
	}

	deleteCustomer(customerId: number) {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/customer';
			const body = {
				customerId: customerId,
				adminId: this.userService.getUserInfo().userId
			};
			const options = new RequestOptions({
				body: body
			});
			this.requestService.requestDelete(url, options, rsp => resolve(), err => reject(err));
		});
	}

	getFeatureToggleSettingsByApp(appName: string) {
		return new Promise<any[]>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/featureToggle';
			const options = new RequestOptions({
				params: {
					application: appName
				}
			});
			this.requestService.requestGet(url, options, rsp => {
				const ftSettings: any[] = [];
				if (rsp.data) {
					rsp.data.forEach((d) => {
						// const ftSetting: FeatureToggleSetting = {
						// 	lbtId: null,
						// 	app: null,
						// 	ftName: null,
						// 	ftLabel: null,
						// 	factorRole: null,
						// 	factorSubLevel: [],
						// 	factorTrialExpire: null,
						// 	factorSuperAdmin: null,
						// 	factorReady: null,
						// 	factorAdminFlag: null,
						// };
						// for (const prop of Object.keys(d)) {
						// 	ftSetting[this.ftSettingColumnMap[prop]] = d[prop];
						// }
						// ftSettings.push(ftSetting);


						// Transform sublevels
						const sublevelCol = this.ftSettingColumnMap.factorSubLevel;
						const sublevels = [];
						const dict = this.appinfoService.dict.subLevels || {};
						for (const level of Object.keys(dict)) {
							sublevels.push({
								name: level,
								id: dict[level],
								selected: d[sublevelCol] ? !!d[sublevelCol].find((l) => l === dict[level]) : false
							});
						}
						d[sublevelCol] = {
							type: 'array-multi',
							list: sublevels
						};
						// Transform role
						const roleCol = this.ftSettingColumnMap.factorRole;
						const roles = [];
						const appRoles = this.appinfoPreService.rolesByApp[appName];
						appRoles.forEach((r) => {
							roles.push({
								name: r.desc,
								id: r.rol_id,
								selected: d[roleCol] ? !!d[roleCol].find((availableId) => availableId === r.rol_id) : false
							});
						});
						d[roleCol] = {
							type: 'array-multi',
							list: roles
						};
						// Transform superAdminOnly & lbtReady & adminFlag
						const booleanIndexList = [
							'factorSuperAdmin',
							'factorReady',
							'factorAdminFlag'
						];
						booleanIndexList.forEach((indexStr) => {
							const col = this.ftSettingColumnMap[indexStr];
							d[col] = {
								type: 'boolean',
								value: d[col]
							};
						});
						// Transform trialExpire
						const trialExpireCol = this.ftSettingColumnMap.factorTrialExpire;
						d[trialExpireCol] = {
							type: 'date',
							value: d[trialExpireCol]
						};

						ftSettings.push(d);
					});
				}
				resolve(ftSettings);
			}, err => reject(err));
		});
	}

	updateFeatureToggleSettings(featureId: number, conditions: ConditionsUpdate) {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/featureToggle';
			const body = {
				featureId: featureId,
				conditions: JSON.stringify(conditions)

				///todo
			};
			this.requestService.requestPut(url, body, rsp => {
				resolve();
			}, err => reject(err));
		});
	}

	// LBM
	getLbmStates() {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/lbmStates';
			this.requestService.requestGet(url, null, rsp => {
				resolve(rsp.data);
			}, err => reject(err));
		});
	}
	updateLbmStates(projectId, projectName, projectDesc, mobile: boolean) {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/lbmStates';
			const body = {
				projectId: projectId,
				projectName: projectName,
				projectDescription: projectDesc,
				mobile: mobile
			};
			this.requestService.requestPut(url, body, rsp => resolve(), err => reject(err));
		});
	}
	getLbmLicenseCount() {
		return new Promise<number>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/lbmLicenseCount';
			this.requestService.requestGet(url, null, rsp => resolve(rsp.data.license_count), err => reject(err));
		});
	}
	updateLbmLicenseCount(count: number) {
		return new Promise<void>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'admin/lbmLicenseCount';
			const body = {
				licenseCount: count
			};
			this.requestService.requestPut(url, body, rsp => resolve(), err => reject(err));
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/super-admin.service.ts